export const win_highlight_popup = {
	WIN_HIGHLIGHT_COUNTER: {
		value: '$600,210',
		config: {
			fontFamily: 'Japanese',
			fontSize: 130,
			letterSpacing: 0,
			align: 'center',
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	}
};
